// employee/reducers.ts
const initialState = {
    getAreaData: [],
    getAreaCount: null,
    createAreaData: null,
    updateAreaData: null,
    getAreaMetaMessage: null,
    getAreaSuccess: false,
    getAreaFailure: false,
    createAreaSuccess: false,
    createAreaFailure: false,
    updateAreaSuccess: false,
    updateAreaFailure: false,
    deleteAreaSuccess: false,
    deleteAreaFailure: false,
};

export default function AreaReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_AREA_TYPE_SUCCESS': {
            return {
                ...state,
                getAreaSuccess: true,
                getAreaData: action.payload?.data?.data?.data,
                getAreaCount:action.payload?.data?.data?.meta?.total,
                getAreaFailure: false,
            };
        }
        case 'GET_AREA_TYPE_FAILURE': {
            return {
                ...state,
                getAreaFailure: true,
                getAreaMetaMessage: action.payload?.data?.data?.meta?.message,
                getAreaSuccess: false,
            };
        }
        case 'RESET_GET_AREA_TYPE': {
            return {
                ...state,
                getAreaSuccess: false,
                getAreaFailure: false,
                getAreaData: [],
                getAreaMetaMessage: null,
            };
        }

        case 'CREATE_AREA_TYPE_SUCCESS': {
            return {
                ...state,
                createAreaSuccess: true,
                createAreaData: action.payload?.data?.data?.data,
                getAreaMetaMessage: action.payload?.data?.data?.meta?.message,
                createAreaFailure: false,
            };
        }
        case 'CREATE_AREA_TYPE_FAILURE': {
            return {
                ...state,
                createAreaFailure: true,
                getAreaMetaMessage: action.payload?.data?.data?.meta?.message,
                createAreaSuccess: false,
            };
        }
        case 'RESET_CREATE_AREA_TYPE': {
            return {
                ...state,
                createAreaSuccess: false,
                createAreaFailure: false,
                createAreaData: null,
                getAreaMetaMessage: null,
            };
        }

        case 'UPDATE_AREA_TYPE_SUCCESS': {
            return {
                ...state,
                updateAreaSuccess: true,
                updateAreaData: action.payload?.data?.data?.data,
                getAreaMetaMessage: action.payload?.data?.data?.meta?.message,
                updateAreaFailure: false,
            };
        }
        case 'UPDATE_AREA_TYPE_FAILURE': {
            return {
                ...state,
                updateAreaFailure: true,
                getAreaMetaMessage: action.payload?.data?.data?.meta?.message,
                updateAreaSuccess: false,
            };
        }
        case 'RESET_UPDATE_AREA_TYPE': {
            return {
                ...state,
                updateAreaSuccess: false,
                updateAreaFailure: false,
                updateAreaData: null,
                getAreaMetaMessage: null,
            };
        }

        case 'DELETE_AREA_TYPE_SUCCESS': {
            return {
                ...state,
                deleteAreaSuccess: true,
                getAreaMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteAreaFailure: false,
            };
        }
        case 'DELETE_AREA_TYPE_FAILURE': {
            return {
                ...state,
                deleteAreaFailure: true,
                getAreaMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteAreaSuccess: false,
            };
        }
        case 'RESET_DELETE_AREA_TYPE': {
            return {
                ...state,
                deleteAreaSuccess: false,
                deleteAreaFailure: false,
                getAreaMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
